.zone {
  position: relative;
  height: 100vh;
}

.dropIt {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2; /* above opened-files flyout in sidebar */
  background-color: rgba(28, 35, 33, 0.7);
  color: white;
  font-size: clamp(4rem, 10vw, 12rem);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10vh;
}
